/* Copyright (c) 2018 Verge Technologies
 * @file nomatch.page.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

import React from 'react';

import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';


const NoMatchPage = () => {
  return (
    <div>
      <Header crumbs={[]} />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '200px' }}>
        <h1>Oops the page you are looking for, isn't here...</h1>
      </div>
      <Footer />
    </div>
  );
};

export default NoMatchPage;



// WEBPACK FOOTER //
// ./src/pages/noMatch/nomatch.page.js